import { compareGroupMapper } from 'container/compareGroupMapper';

import { QuestionMapper } from '../mapper/QuestionMapper';

export const questionMapper = new QuestionMapper(compareGroupMapper);
